export default __webpack_public_path__ + "static/media/refund-icon.c6bf660d.svg";